export const getBuyerInstallments = 'Buyer/GetInstallments';
export const getBuyerHPData = 'Buyer/GetHomePageData';
